import _ from 'lodash'
import { SET_SERVERS, SET_ENABLED_SERVERS } from './constants'
import { getDefaultServer } from './selectors'

// Initial state of the store
const initialState = {}
// Sample state:
// {
//     duality: {
//         enabled: true,
//         name: 'Duality',
//         serverId: 'duality',
//         sso: {
//             slinger: 'slinger-duality.testeveonline.com',
//             url: 'dualitylogin.testeveonline.com',
//         },
//         status: 'offline',
//         statusLabel: 'Offline', ...?? shouldn't this be localized based on status???
//         websiteUrl: 'https://launcher.testeveonline.com',
//     }
// }

export default function servers(state = initialState, action) {
    switch (action.type) {
        // Replace the list of EVE Online servers
        case SET_SERVERS:
            return action.payload

        // TQ and the given list should be enabled, all others disabled
        case SET_ENABLED_SERVERS: {
            return _.reduce(
                state,
                (serverList, server, serverId) => {
                    // First add the server to the result
                    serverList[serverId] = { ...server, sso: { ...server.sso } }

                    // Set enabled if TQ or if in list
                    serverList[serverId].enabled =
                        serverId === getDefaultServer() ||
                        (action.payload || []).indexOf(serverId) !== -1
                    return serverList
                },
                {},
            )
        }

        // Do nothing
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/servers/reducer.js